export default __webpack_public_path__ + "static/media/privacy.10375402.jpg";